/**
 * What an artist's square shows when there is no photo (no Spotify match, or the image failed). It was an empty grey
 * tile, which read as still loading. Now the artist's initial on a colour of its own (Sam's pick 2026-10-23, option 4
 * of 4): steady per name, kept to the brand's blue-violet-to-pink band, so a lineup with several missing photos is not
 * a row of identical tiles.
 */

const initialOf = (name) =>
  (
    String(name || '')
      .trim()
      .replace(/^the\s+/i, '')
      .match(/[\p{L}\p{N}]/u)?.[0] ?? ''
  ).toUpperCase();

function hueOf(name) {
  let h = 0;
  for (const c of String(name || '')) h = (h * 31 + c.codePointAt(0)) >>> 0;
  return 250 + (h % 80);
}

export default function ArtistPlaceholder({ name, className = '' }) {
  const h = hueOf(name);
  return (
    <div
      className={`${className} flex items-center justify-center overflow-hidden`}
      style={{ background: `linear-gradient(145deg, hsl(${h} 62% 52%), hsl(${h + 18} 58% 28%))` }}
      aria-hidden
    >
      <span style={{ fontWeight: 800, fontSize: '0.95em', color: '#fff' }}>{initialOf(name)}</span>
    </div>
  );
}
